const STEPS = [
  {
    icon: "ri-links-line",
    title: "追到原始出处",
    text: "别停在转载页。尽量找到最接近源头的那条消息——是谁首发、原文还在不在，是判断真伪的第一步。",
  },
  {
    icon: "ri-fingerprint-line",
    title: "核对信息源身份",
    text: "看信息来自当事人、机构通报，还是匿名爆料、营销号搬运。来源的身份与利益关系，直接决定可信度。",
  },
  {
    icon: "ri-shuffle-line",
    title: "寻找交叉印证",
    text: "同一事实若有多个彼此独立、互不知情的信源佐证，可信度明显更高。单点孤证，多留个心眼。",
  },
  {
    icon: "ri-emotion-2-line",
    title: "识别情绪化表达",
    text: "大量感叹号、断言式结论、攻击性措辞，往往是带节奏的信号。证据该由事实说话，而不是由语气。",
  },
  {
    icon: "ri-calendar-todo-line",
    title: "等待时间验证",
    text: "一时难辨真假时，不妨把结论缓一缓。让子弹飞一会儿，新证据与后续回应会帮你修正判断。",
  },
];

export default function FactCheckSection() {
  return (
    <section id="check" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div className="max-w-2xl">
            <p className="flex items-center gap-2 text-xs tracking-widest text-primary-600 uppercase">
              <i className="ri-search-eye-line w-4 h-4 flex items-center justify-center" />
              04 · 核实方法
            </p>
            <h2 className="mt-3 font-heading font-bold text-2xl md:text-4xl text-foreground-950">
              信息真伪，五步核实法
            </h2>
            <p className="mt-4 text-foreground-700 text-sm md:text-base leading-loose">
              面对满天飞的截图与‘实锤’，与其跟着情绪走，不如用一套简单动作过滤噪音。
              把下面五步当作默认习惯，绝大多数争议你都能站得住脚。
            </p>
          </div>
          <span className="inline-flex items-center gap-2 text-xs px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-700">
            <i className="ri-shield-check-line w-4 h-4 flex items-center justify-center" />
            理性吃瓜 · 拒绝被带节奏
          </span>
        </div>

        <div className="mt-10 flex flex-col gap-3">
          {STEPS.map((s, i) => (
            <div
              key={s.title}
              className="flex flex-col sm:flex-row items-start gap-4 bg-background-50 border border-background-200 rounded-lg p-5"
            >
              <div className="flex items-center gap-3 w-full sm:w-72 flex-shrink-0">
                <span className="w-10 h-10 flex items-center justify-center rounded-md bg-accent-500 text-background-50">
                  <i className={`${s.icon} text-lg w-5 h-5 flex items-center justify-center`} />
                </span>
                <div>
                  <p className="font-label text-xs text-secondary-600">STEP {i + 1}</p>
                  <h3 className="font-heading font-semibold text-base text-foreground-950">{s.title}</h3>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed sm:border-l sm:border-background-200 sm:pl-5">
                {s.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}